import { Link } from 'react-router-dom';
import { Logo } from '../components/Logo';
import { Button } from '../ui';

export function NotFoundScreen() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-navy p-8 text-center">
      <Logo size="md" className="mb-6" />
      <h1 className="text-3xl font-serif text-white mb-3">Page not found</h1>
      <p className="text-gray-400 max-w-md mb-6">
        The page you're looking for doesn't exist, or you don't have access to it.
      </p>
      <Link to="/cases">
        <Button variant="primary" size="md">Back to cases</Button>
      </Link>
    </div>
  );
}
